import { gtmFormError } from 'helpers/utils/gtm-events/gtmInteraction';
import { useEffect, useRef, useState } from 'react';

interface Props {
  formName: string;
  errors?: any;
}
function FormEventsAnalyticsTracker({ formName, errors }: Props) {
  const [fieldsWithError, setFieldsWithError] = useState<string[]>([]);
  useEffect(() => {
    Object.keys(errors).forEach((fieldName) => {
      if (errors[fieldName] && !fieldsWithError.includes(fieldName)) {
        setFieldsWithError((prev) => [...prev, fieldName]);
        gtmFormError({ errorField: fieldName, errorMessage: errors[fieldName].message, formName: formName });
      }
    });
  });
  return <></>;
}
export default FormEventsAnalyticsTracker;
